import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import useAnalyticsFilesTableContextValue from './useAnalyticsFilesTableContextValue';

const AnalyticsFilesTableContext = createContext({});

export function useAnalyticsFilesTableContext() {
  return useContext(AnalyticsFilesTableContext);
}

export default function AnalyticsFilesTableContextProvider({ children }) {
  const contextValue = useAnalyticsFilesTableContextValue();

  return <AnalyticsFilesTableContext.Provider value={contextValue}>{children}</AnalyticsFilesTableContext.Provider>;
}

AnalyticsFilesTableContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
